var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplyEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.12,28.07a.17.17,0,0,0,.11-.16V26.05h4.22a.17.17,0,0,0,.17-.15V23.18a.17.17,0,0,0-.17-.17H21.23V21.15A.2.2,0,0,0,21,21l-.06,0-3.4,3.4a.17.17,0,0,0-.05.12.12.12,0,0,0,.05.12L20.93,28A.19.19,0,0,0,21.12,28.07Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73,13.6c7.72,5.25,5.79,5.65,11.65,1.43,1.29-.93,3.08-1.86,3.86-3a2.26,2.26,0,0,0,.14-2.64c-.57-.64-1.06-.57-1.93-.57H9.52a12.34,12.34,0,0,0-1.72,0,1.25,1.25,0,0,0-1.06.64,2.4,2.4,0,0,0-.36,1.36C6.52,12,7.88,13,8.73,13.6Z",
    style: {
      fill: "#eac282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.76,18a.29.29,0,0,1,.4.11s0,0,0,0a.14.14,0,0,1,0,.09v2.86h2.54V13.46c-.41.38-.85.74-1.3,1.08-2.42,1.84-6.69,4.69-7.87,4.74s-5.45-2.88-7.82-4.74a15.52,15.52,0,0,1-1.33-1.1v7.1a7.74,7.74,0,0,0,.06,1.36,1.65,1.65,0,0,0,1.61,1.28h8.5Z",
    style: {
      fill: "#eac282"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyEmail);
export default __webpack_public_path__ + "static/media/reply-email.e3af1903.svg";
export { ForwardRef as ReactComponent };